var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.708 6A8.967 8.967 0 0 1 23 12a8.967 8.967 0 0 1-2.292 6M5 7.904H3.333C2.597 7.904 2 8.474 2 9.178v5.644c0 .704.597 1.274 1.333 1.274H5m0-8.192v8.192m0-8.192 4.72-4.758C11.022 2.11 13 2.994 13 4.614v14.772c0 1.62-1.978 2.505-3.28 1.468L5 16.096m13.667-7.867A5.975 5.975 0 0 1 20 12a5.975 5.975 0 0 1-1.299 3.729M20.87 3 4.5 21M13 8.178v7.644c2.21 0 4-1.711 4-3.822 0-2.11-1.79-3.822-4-3.822Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteOn);
export default __webpack_public_path__ + "static/media/mute_on.2e9548b7b2db0c54e479be7fb5d31a65.svg";
export { ForwardRef as ReactComponent };